export enum FileRelationshipTypeEnum {
    Unknown = 0,
    EOI = 8,
    DependentVerification = 9,
    EnrolledConfirmationStatements = 14,
    CancelledCoverageConfirmationStatements = 15,
    NewlyEnrolledConfirmationStatements = 16,
    ChangingCoverageConfirmationStatements = 17,
}
